<script>
  import { afterUpdate } from 'svelte'
  import Formrow from "../shared/formrow.svelte"
  import {countries,states} from "../account/account-store.js"
  export let user = {}
  export let fixed = false
  countries.load()
  afterUpdate(()=>{
    if(user.country=="US") states.load()
  })
</script>

<Formrow label="Email" type="email" required name="email" {fixed} bind:value={user.email}></Formrow>
<Formrow label="Forename" type="text" required name="forename" {fixed} bind:value={user.first_name}></Formrow>
<Formrow label="Surname"  type="text" required name="surname" {fixed} bind:value={user.surname}></Formrow>
<Formrow label="Organisation"  type="text" name="organisation" {fixed} bind:value={user.organisation}></Formrow>
<Formrow label="Address" type="textarea" rows="4" required name="address" {fixed} bind:value={user.address}></Formrow>
<Formrow label="Town/City" type="text" required name="city" {fixed} bind:value={user.city}></Formrow>
<Formrow label="Postcode" type="text" required name="postcode" {fixed} bind:value={user.postcode}></Formrow>
{#if user.country=="US"}
  <Formrow label="State" type="select" required name="state" {fixed} bind:value={user.state}>
    <option value="">Please Select</option>
    {#each $states as state}
      <option value={state.code} selected={state.code==user.state}>{state.name}</option>
    {/each}
  </Formrow>
{/if}
<Formrow label="Country" type="select" required name="state" {fixed} bind:value={user.country}>
  <option value="">Please Select</option>
  {#each $countries as country}
    <option value={country.code} selected={country.code==user.country}>{country.name}</option>
  {/each}
</Formrow>
<Formrow label="Telephone" type="tel" required name="telephone" {fixed} bind:value={user.phone1}></Formrow>
<Formrow label="Mobile" type="tel" name="mobile" {fixed} bind:value={user.phone2}></Formrow>